module.exports = __webpack_public_path__ + "img/12227@3x.5cd1ab92.png";